import { useEffect, useState } from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { Table, Tabs } from "antd";
import { ColumnsType } from "antd/es/table";
import { WithAuth } from "@/hoc";
import { UserDataV2 } from "@/models";
import { useUsers } from "@/hooks";
import { AdicionarUsuario } from "./_adicionar_usuario";
import { DeletUser } from "./_deletar_usuario";
import { MenuListUser } from "./_menu_user";
import { useUsersContext } from "@/contexts/userContext";
import { DynamicTable } from "@/components/DynamicTable";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";


const Usuarios = () => {
  const { users } = useUsersContext();
  const { getUsers } = useUsers();
  const { loading, execute } = useAsyncFunction(getUsers);
  function getStatus(stats: string) {
    const statusMap: Record<string, string> = {
      ACTIVE: "ATIVO",
      INACTIVE: "INATIVO",
      CREATED: "CRIADO",
      BLOCKED: "BLOQUEADO",
    };

    return statusMap[stats] || stats;
  }
  function getStatusColor(stats: string) {
    const statusColorMap: Record<string, string> = {
      ACTIVE: "green.300",
      INACTIVE: "gray.400",
      CREATED: "blue.400",
      BLOCKED: "red.500",
    };

    return statusColorMap[stats] || "gray.300"; // fallback neutro
  }

  useEffect(() => {
    execute();
  }, []);

  const columns = [
    {
      key: "email",
      title: "Usuários",
      dataIndex: "email",
      render: (email) => (
        <Flex align="center">

          <Text>{email}</Text>
        </Flex>
      ),
    },
    {
      key: "status",
      title: "status",
      dataIndex: "status",
      render: (status) => (


        <Flex
          align="center"
          justify="center"
          px="2"
          py="1"
          bg={getStatusColor(status)}
          borderRadius="full"
          w="fit-content"
        >
          <Text
            fontSize="xs"
            fontWeight="bold"
            color="white"
          >
            {getStatus(status)}
          </Text>
        </Flex>
      ),
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      emptyText: true,
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      emptyText: true,
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      emptyText: true,
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      emptyText: true,
    },
    {
      key: "buttonOptions",
      title: "",
      dataIndex: "buttonOptions",
      render: (text, record) => (
        record?.status !== "CREATED" ? (
          <MenuListUser user={record} />
        ) : null
      )
    },
  ];

  return (
    <Box>
      <Flex 
        justify="space-between" 
        mb="20px"
        align="center"
      >
        <Heading size="lg">Usuários</Heading>
        <AdicionarUsuario />
      </Flex>
      <DynamicTable
        columns={columns}
        data={users}
        rowKey={(record) => record.id}
        loading={loading}
        locale={{ emptyText: "Sem dados de usuários" }}
      />
    </Box>
  );
};

export default WithAuth(Usuarios);
